const midPart = [
  {
    lat: 12.238791,
    lng: 109.196747,
    place: "Nha Trang",
    time: "6.5 giờ lái xe",
    src:
      "https://cungphuot.info/wp-content/uploads/2015/04/kinh-nghiem-du-lic-nha-trang-1.jpg",
  },
  {
    lat: 10.10226,
    lng: 103.99415,
    place: "Phú Quốc",
    time: "",
    src:
      "https://dulichviet.com.vn/images/bandidau/NOI-DIA/Phu-Quoc/Phu-Quoc-anh-dai-dien/tour-du-lich-phu-quoc-sunset-sanato-du-lich-viet.jpg",
  },
  {
    lat: 13.08883,
    lng: 109.317482,
    place: "Thành phố Tuy Hòa ",
    time: "7.5 giờ lái xe",
    src:
      "https://vietjet.net/includes/uploads/2017/06/ve-may-bay-gia-re-di-tuy-hoa-600x375-1-600x375.jpg",
  },
  {
    lat: 11.582557154470548,
    lng: 108.99086114342384,
    place: "Phan Rang - Tháp Chàm",
    time: "5 giờ lái xe",
    src:
      "https://cungphuot.info/wp-content/uploads/2015/04/kinh-nghiem-du-lic-nha-trang-1.jpg",
  },
  {
    lat: 12.668453121018812,
    lng: 108.03833271212791,
    place: "Thành phố Buôn Ma Thuột",
    time: "5 giờ lái xe",
    src:
      "https://lh3.googleusercontent.com/-fc5TIMr9zhQ/VTUyhuyqA9I/AAAAAAAABEs/ZLek1Hf55X4/s400/Ti%25C3%25AAu%2Bh%25E1%25BA%25A1t%2BBu%25C3%25B4n%2BMa%2BThu%25E1%25BB%2599t%2B-%2Btieuhatbmt%2B%2528153%2529.jpg",
  },
  {
    lat: 10.342311489482121,
    lng: 107.08306758042079,
    place: "Hồ Tràm",
    time: "2.5 giờ lái xe",
    src:
      "https://pix10.agoda.net/hotelImages/5873834/0/791219c690ece220e70675a61c8bc4aa.jpg?s=1024x768",
  },
  {
    lat: 13.970204626276828,
    lng: 108.01365642157118,
    place: "Thành phố PleiKu",
    time: "7.5 giờ lái xe",
    src:
      "https://cungphuot.info/wp-content/uploads/2015/04/kinh-nghiem-du-lic-nha-trang-1.jpg",
  },
  {
    lat: 13.580002825820314,
    lng: 109.20582174206619,
    place: "Thị xã Sông Cầu",
    time: "8.5 giờ lái xe",
    src:
      "https://cdn.vntrip.vn/cam-nang/wp-content/uploads/2017/10/Song-Cau-Phu-Yen-3-e1507259332708.png",
  },
];
export default midPart;
